import { defineSagaForService } from '@repo/core'
import {
  fileDownloadConfig as fileDownloadConfigRead,
  serviceConfig as serviceConfigRead,
} from './read'

export * from './read'
export * from './write'

export const serviceConfig = defineSagaForService({ ...serviceConfigRead })
export const fileDownloadConfig = { ...fileDownloadConfigRead }
